module.exports = __webpack_public_path__ + "static/media/userInfo.22ca3c07.svg";